export const BODY_CLASS_SCROLL_LOCK = 'scroll-lock';

export const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export const intersectionAnimations: { [key: string]: { className: string; duration: number } } = {
  flyIn: {className: 'fly-in', duration: 2000},
  zoomIn: {className: 'zoom-in', duration: 2000},
  fadeIn: {className: 'fade-in', duration: 2000},
};
